import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Leadership',
    path: '/leadership'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100" data-id="element-81">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <div className="flex justify-between items-center h-20" data-id="element-83">
          <div className="flex-shrink-0 flex items-center" data-id="element-84">
            <Link to="/" data-id="element-85">
              <img src="https://cdn.magicpatterns.com/uploads/aWQSKdCC9bQ3YkJsWHEuVT/Global_Restorative3_(1).jpg" alt="Global Restorative Health & Wellness LLC" className="h-14 md:h-16 w-auto" data-id="element-86" />
            </Link>
          </div>

          <nav className="hidden md:flex space-x-8 items-center" data-id="element-87">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-bold uppercase tracking-wider transition-colors ${location.pathname === link.path ? 'text-brand-red' : 'text-brand-navy hover:text-brand-red'}`} data-id="element-88">
                {link.name}
              </Link>)}
            <Link to="/contact" className="bg-brand-navy text-white px-6 py-2.5 rounded-md font-bold text-sm uppercase tracking-widest hover:bg-brand-red transition-all shadow-md" data-id="element-89">
              Book Consultation
            </Link>
          </nav>

          <div className="md:hidden" data-id="element-90">
            <button onClick={() => setIsOpen(!isOpen)} className="text-brand-navy p-2" data-id="element-91">
              {isOpen ? <XIcon className="h-6 w-6" data-id="element-92" /> : <MenuIcon className="h-6 w-6" data-id="element-93" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-white border-t border-gray-100 py-4 px-4 space-y-2 shadow-xl" data-id="element-94">
          {navLinks.map(link => <Link key={link.path} to={link.path} onClick={() => setIsOpen(false)} className={`block py-3 px-4 rounded-lg font-bold ${location.pathname === link.path ? 'bg-brand-red/10 text-brand-red' : 'text-brand-navy'}`} data-id="element-95">
              {link.name}
            </Link>)}
          <div className="pt-4" data-id="element-96">
            <Link to="/contact" onClick={() => setIsOpen(false)} className="block w-full text-center bg-brand-navy text-white py-4 rounded-xl font-bold" data-id="element-97">
              Book Consultation
            </Link>
          </div>
        </div>}
    </header>;
}